// ============================================
// COMPONENT - Modal rechazar movimiento pendiente (propietario)
// ============================================

import { useState } from 'react';
import { Button } from '@almacenes/ui';
import { MdClose } from 'react-icons/md';

interface RechazarMovimientoModalProps {
  onClose: () => void;
  onConfirmar: (motivo: string) => void;
  isLoading: boolean;
}

export const RechazarMovimientoModal = ({ onClose, onConfirmar, isLoading }: RechazarMovimientoModalProps) => {
  const [motivo, setMotivo] = useState('');
  const [error, setError] = useState<string | undefined>(undefined);

  const handleConfirmar = () => {
    if (!motivo.trim()) {
      setError('El motivo del rechazo es obligatorio');
      return;
    }
    onConfirmar(motivo.trim());
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-start mb-6">
          <h3 className="text-2xl font-bold" style={{ color: '#11194F' }}>Rechazar movimiento</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <MdClose className="text-2xl" />
          </button>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: '#11194F' }}>
            Motivo <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={motivo}
            maxLength={255}
            onChange={(e) => { setMotivo(e.target.value); if (error) setError(undefined); }}
            placeholder="Explica por qué se rechaza este movimiento"
            className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 transition-all ${
              error ? 'border-red-500 focus:ring-red-200' : 'border-gray-300 focus:ring-blue-200'
            }`}
            disabled={isLoading}
          />
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>

        <div className="flex gap-3 pt-6">
          <Button variant="secondary" onClick={onClose} disabled={isLoading} className="flex-1">
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirmar} isLoading={isLoading} disabled={isLoading} className="flex-1">
            Rechazar
          </Button>
        </div>
      </div>
    </div>
  );
};
